// extracted by mini-css-extract-plugin
export default {"border-bottom":"LBQ5B_wiLSGDrgI_EaOy","borderBottom":"LBQ5B_wiLSGDrgI_EaOy","border-top":"hWhrOiSbAKHGWMWZRwrl","borderTop":"hWhrOiSbAKHGWMWZRwrl"};